import { generateUid } from "./uid";
import { Vector3 } from "../math/vector";
import { Matrix4 } from "../math/matrix";
export class Object3D {
    constructor() {
        this.uid = generateUid();
        this.matrix = new Matrix4();
        this.centroid = Vector3.fromValues(0, 0, 0);
    }
    translate(x, y, z) {
        this.matrix.translate(x, y, z);
    }
    rotate(rad, x, y, z) {
        this.matrix.rotate(rad, x, y, z);
    }
    scale(x, y, z) {
        this.matrix.scale(x, y, z);
    }
    setColor(color) {
        this.color = color;
    }
}
